// import './Splash.css';

function Battledrift() {

  
  return (
    <div style={{height: '100%', marginLeft: '12%', marginRight:'12%'}} className="pure-g">
      <div className="pure-u-1 pure-u-lg-3-5">
        <div className="blue-border video-holder">
          <iframe src="https://www.youtube.com/embed/Ca3MY1LxYH4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
          </iframe>
        </div>
        <div className="blue-border">
          <div class="formatted_description user_formatted"><h2><span></span>
          <img src="/BannerAnimated.gif" style={{width: '100%'}} alt="BATTLEDRIFT Banner" loading="lazy"/><span></span></h2>
          <p><span></span>
          </p>
          <h2><u>BATTLEDRIFT - 4 Player Battle in Space</u></h2>
          <p>Your ship is stranded in a warzone and is completely out of fuel! You'll have to use your ample artillery as propulsion. Use your own gun recoil to push yourself around as you face off against each other with up to 4 human or CPU players.
          </p><p><img src="LevelShowcase.gif"  style={{width: '100%'}} alt="Grid showing variety of levels" loading="lazy"/></p>
          <p>
          </p>
          <p><span></span>
          </p>
          <p>
          </p>
          <h2><u>Play your way - 3 Bullet Types</u></h2>
          <p><strong>Laser</strong></p><p><img src="/Bullet_Laser.gif" alt="Laser Bullet Demonstration"  style={{width: '100%'}} loading="eager"/></p>
          <p><span></span>
          </p>
          <p>
          </p>
          <p>Bullets travel faster and can block each other
          </p>
          <p>
          </p>
          <p><strong>Ghost</strong>
          </p><p><img src="/Bullet_Ghost.gif" alt="Ghost Bullet Demonstration"  style={{width: '100%'}} loading="eager"/></p>
          <p><span></span>
          </p>
          <p>
          </p>
          <p>Bullets can pass through each other
          </p>
          <p>
          </p>
          <p><strong>Rubber</strong>
          </p><p><img src="/Bullet_Rubber.gif" alt="Rubber Bullet Demonstration"  style={{width: '100%'}} loading="eager"/></p>
          <p><span></span>
          </p>
          <p>
          </p>
          <p>Bullets bounce off of everything for maximum chaos!
          </p>
          <h2><u>Game Features:</u></h2>
          <ul><li>Single player with multiple levels of CPU difficulty.
          </li><li>Local multiplayer with up to 4 players.
          </li><li>Three different bullet types for extra variety - try them all!
          <p></p><ul><li>Ghost - Bullets pass through everything except enemy ships.
          </li><li>Laser - Like ghost, but bullets can block other bullets.
          </li><li>Rubber - Ship velocity affects bullet velocity, bullets bounce off of everything for maximum chaos!
          </li></ul>
          </li></ul>
          <ul><li>Support for both gamepad and keyboard (3-4 players on keyboard depending on keyboard size).
          </li><li>Simple controls, all menus and gameplay are accessible using only the 4 arrows keys (and the ESC key for pausing).
          </li><li>3 Levels in the demo, 10 levels planned for the full release!</li></ul>
          </div>
        </div>
      </div>
      <div className="pure-u-1 pure-u-lg-2-5">
        <div className="blue-border">
          <img src='/Neon3.jpg' style={{width:'100%'}} alt="Screenshot showing ships fighting with bullets visible on the screen"></img>
          <img src='/Neon2.jpg' style={{width:'100%'}} alt="Screenshot showing ships fighing, one is leaving behind a smoke trail"></img>
          <img src='/YellowVictory.jpg' style={{width:'100%'}} alt="A match summary screen showing yellow ship has won"></img>
        </div>
      </div>
      <div className="blue-border pure-u-1">
        <p>You can purchase the game from the following sources after release:</p>
        <ul>
          <li><a href="https://store.steampowered.com/app/4416830/BATTLEDRIFT/">Steam</a></li>
          <li><a href="https://dragonduckgames.itch.io/battledrift">Itch.io</a></li>
        </ul>
      </div>
    </div>
  );
}

export default Battledrift;
